module.exports = __webpack_public_path__ + "assets/img/2022_07.24a312ec.png";